import React from "react";
import { useAccount } from 'wagmi';
import { useWeb3Modal } from '@web3modal/wagmi/react'
import { trimAddress } from "../hooks/constant";




export const Connect = function ({ className }) {
    const { address, isConnected } = useAccount()
    const { open } = useWeb3Modal()


    return (
        <React.Fragment>

            <>
                {address && isConnected ? (
                    <button type="button" className={className} onClick={() => open()}>
                        {trimAddress(address)}
                    </button>

                ) : (
                    <button type="button" className={className} onClick={() => open()}>
                        Connect
                    </button>
                )
                }

            </>

        </React.Fragment >
    );
};

export default Connect;